/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const accountRetrieveCurrentFeatureFlagsItemNameMax = 255;

export const accountRetrieveCurrentFeatureFlagsItemCodeMax = 255;

export const AccountRetrieveCurrent = zod.strictObject({
    id: zod.number(),
    name: zod.string(),
    default_version: zod
        .strictObject({
            id: zod.number(),
            data_source: zod.strictObject({
                id: zod.number(),
                url: zod.string().nullable(),
            }),
        })
        .nullish(),
    other_accounts: zod
        .array(
            zod.strictObject({
                id: zod.number(),
                name: zod.string(),
            }),
        )
        .nullable(),
    modules: zod
        .array(
            zod
                .enum([
                    'DATA_COLLECTION_FORMS',
                    'DEFAULT',
                    'DHIS2_MAPPING',
                    'EMBEDDED_LINKS',
                    'ENTITIES',
                    'EXTERNAL_STORAGE',
                    'PLANNING',
                    'POLIO_PROJECT',
                    'REGISTRY',
                    'PAYMENTS',
                    'COMPLETENESS_PER_PERIOD',
                    'TRYPELIM_PROJECT',
                    'DATA_VALIDATION',
                    'SAAS',
                    'STOCK_MANAGEMENT',
                    'SNT_MALARIA',
                    'FORM_AI',
                    'VALIDATION_WORKFLOW',
                ])
                .describe(
                    '\* `DATA_COLLECTION_FORMS` - Data collection - Forms\n\* `DEFAULT` - Default\n\* `DHIS2_MAPPING` - DHIS2 mapping\n\* `EMBEDDED_LINKS` - Embedded links\n\* `ENTITIES` - Entities\n\* `EXTERNAL_STORAGE` - External storage\n\* `PLANNING` - Planning\n\* `POLIO_PROJECT` - Polio project\n\* `REGISTRY` - Registry\n\* `PAYMENTS` - Payments\n\* `COMPLETENESS_PER_PERIOD` - Completeness per Period\n\* `TRYPELIM_PROJECT` - Trypelim project\n\* `DATA_VALIDATION` - Change requests\n\* `SAAS` - SaaS\n\* `STOCK_MANAGEMENT` - Stock management\n\* `SNT_MALARIA` - SNT Malaria\n\* `FORM_AI` - Form AI\n\* `VALIDATION_WORKFLOW` - Validation workflow',
                ),
        )
        .nullable(),
    feature_flags: zod
        .array(
            zod.strictObject({
                name: zod
                    .string()
                    .max(accountRetrieveCurrentFeatureFlagsItemNameMax),
                code: zod
                    .string()
                    .max(accountRetrieveCurrentFeatureFlagsItemCodeMax),
            }),
        )
        .nullish(),
});

export type AccountRetrieveCurrent = zod.input<typeof AccountRetrieveCurrent>;
export type AccountRetrieveCurrentOutput = zod.output<
    typeof AccountRetrieveCurrent
>;
